const t = {
  name: "Share1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0001 9.41437L13 6.41427V14.0002H11V6.41446L8.00009 9.41436L6.58588 8.00015L12.0001 2.58594L17.4143 8.00015L16.0001 9.41437Z" fill="currentColor"/>
<path d="M12 19.0002C8.68629 19.0002 6 16.3139 6 13.0002H4C4 17.4185 7.58172 21.0002 12 21.0002C16.4183 21.0002 20 17.4185 20 13.0002H18C18 16.3139 15.3137 19.0002 12 19.0002Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Share1
};
